<div class="selector-field-container">
  <div *ngIf="label()" class="selector-field-container__label">
    {{ label() }}
  </div>
  <div
    class="selector-field-container__control"
    tabindex="0"
    (keydown.enter)="selectorFieldHandler()?.()"
    [ngClass]="{
      'selector-field-container__control--disabled': disabled(),
      'selector-field-container__control--empty': empty()
    }"
    (click)="selectorFieldHandler()?.()"
  >
    <ng-content></ng-content>
  </div>
</div>
